/**
 * Scrolls `element` into view within its scrollable ancestors, stopping at `boundary` (inclusive).
 * Unlike `element.scrollIntoView()`, containers outside the boundary are never scrolled, so moving
 * focus inside a menu cannot scroll the page or a drawer behind it.
 */
export default function scrollIntoViewWithin(element, boundary) {
  if (!element || !boundary) {
    return;
  }

  let container = element.parentElement;
  while (container) {
    if (container.scrollHeight > container.clientHeight) {
      const containerTop = container.getBoundingClientRect().top + container.clientTop;
      const containerBottom = containerTop + container.clientHeight;
      const { top, bottom } = element.getBoundingClientRect();

      if (top < containerTop) {
        container.scrollTop -= containerTop - top;
      } else if (bottom > containerBottom) {
        container.scrollTop += bottom - containerBottom;
      }
    }

    if (container === boundary) {
      return;
    }
    container = container.parentElement;
  }
}
